export const email = `${process.env.PUBLIC_URL}/assets/email.png`;
export const mobile = `${process.env.PUBLIC_URL}/assets/mobile.png`;
export const api = `${process.env.PUBLIC_URL}/assets/api.png`;
export const cpp = `${process.env.PUBLIC_URL}/assets/cpp.png`;
export const css = `${process.env.PUBLIC_URL}/assets/css.png`;
export const figma = `${process.env.PUBLIC_URL}/assets/figma.png`;
export const flutter = `${process.env.PUBLIC_URL}/assets/flutter.png`;
export const git = `${process.env.PUBLIC_URL}/assets/git.png`;
export const graphql = `${process.env.PUBLIC_URL}/assets/graphql.png`;
export const html = `${process.env.PUBLIC_URL}/assets/html.png`;
export const javascript = `${process.env.PUBLIC_URL}/assets/javascript.png`;
export const mu5 = `${process.env.PUBLIC_URL}/assets/mu5.png`;
export const node = `${process.env.PUBLIC_URL}/assets/node.png`;
export const python = `${process.env.PUBLIC_URL}/assets/python.png`;
export const react = `${process.env.PUBLIC_URL}/assets/react.png`;
export const redux = `${process.env.PUBLIC_URL}/assets/redux.png`;
export const sass = `${process.env.PUBLIC_URL}/assets/sass.png`;
export const typescript = `${process.env.PUBLIC_URL}/assets/typescript.png`;
export const vue = `${process.env.PUBLIC_URL}/assets/vue.png`;
export const bootstrap = `${process.env.PUBLIC_URL}/assets/bootstra.webp`;
export const nextjs = `${process.env.PUBLIC_URL}/assets/nextjs.png`;
export const styledComponents = `${process.env.PUBLIC_URL}/assets/styledcomponents.png`;
export const mongoDb = `${process.env.PUBLIC_URL}/assets/mongodb.png`;
export const sql = `${process.env.PUBLIC_URL}/assets/sql.png`;
export const reactNative = `${process.env.PUBLIC_URL}/assets/react-native.png`;

export const about01 = `${process.env.PUBLIC_URL}/assets/about01.jpg`;
export const about02 = `${process.env.PUBLIC_URL}/assets/about02.jpg`;
export const about03 = `${process.env.PUBLIC_URL}/assets/about03.jpg`;
export const about04 = `${process.env.PUBLIC_URL}/assets/about04.gif`;

export const profile = `${process.env.PUBLIC_URL}/assets/profile.jpg`;
export const circle = `${process.env.PUBLIC_URL}/assets/circle.svg`;
export const logo = `${process.env.PUBLIC_URL}/assets/logo.png`;

export const youtube = `${process.env.PUBLIC_URL}/assets/youtube.jpg`;
export const disneyPlus = `${process.env.PUBLIC_URL}/assets/disneyplus.jpg`;
export const spaceTurism = `${process.env.PUBLIC_URL}/assets/space-turism.jpg`;

export const mocha = `${process.env.PUBLIC_URL}/assets/mocha.png`;
export const chai = `${process.env.PUBLIC_URL}/assets/chai.png`;
export const jest = `${process.env.PUBLIC_URL}/assets/jest.png`;
export const testing = `${process.env.PUBLIC_URL}/assets/mocha.png`;
